<script lang="ts">
    import {getContext} from 'svelte';
    import {CONTEXT_PATH_KEY, LOCALIZE_KEY} from '../../../svelte/utils';
    import type {AvailableSize} from './types';
    import type {LocalizeFunction} from '../../../svelte/types';

    export let size: AvailableSize;

    const CONTEXT_PATH: string = getContext(CONTEXT_PATH_KEY);
    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);

    const sizeToDimensionMap: Record<AvailableSize, number> = {
        xs: 16,
        sm: 32,
        md: 64,
        lg: 128
    }

    const width = sizeToDimensionMap[size];
    const height = sizeToDimensionMap[size];
    const imageSrc = `${CONTEXT_PATH}${require('./loading-spinner.svg')}`;
</script>

<template>
    <img class="kp-loading" width={width} height={height} alt="{localize(/* @kp-localization commons.LoadingInProgress */ 'commons.LoadingInProgress')}" src={imageSrc}>
</template>


